// Import CSS reset and Global Styles
import './index.scss';

import bindRaven from './raven';
import hookRouter from './router';
import bindPlugins from './plugins';

const start = () => {
  // Enabling Raven error capturing
  bindRaven();

  // Loading plugins
  bindPlugins();

  // Hooking router
  hookRouter();
};

start();



// WEBPACK FOOTER //
// ./src/index.js